export default __webpack_public_path__ + "static/media/leaderboard-cn.2235bcaa.gif";